import { useQuery } from '@tanstack/react-query'

import { useApiContext } from '../context/ApiContext'

export function useProjectInvites() {
  const { apiClient } = useApiContext()

  return useQuery(['projectInvites'], () => apiClient.getProjectInvites(), { retry: 2 })
}
